import { render, staticRenderFns } from "./RiskAssessmentWrite.vue?vue&type=template&id=3151cbdf&scoped=true"
import script from "./RiskAssessmentWrite.vue?vue&type=script&lang=js"
export * from "./RiskAssessmentWrite.vue?vue&type=script&lang=js"
import style1 from "./RiskAssessmentWrite.vue?vue&type=style&index=1&id=3151cbdf&prod&scoped=true&lang=css"
import style2 from "./RiskAssessmentWrite.vue?vue&type=style&index=2&id=3151cbdf&prod&lang=scss&scoped=true"
import style3 from "./RiskAssessmentWrite.vue?vue&type=style&index=3&id=3151cbdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151cbdf",
  null
  
)

export default component.exports